module.exports = __webpack_public_path__ + "static/img/KPX.52ee79f.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPX.png
// module id = p7D/
// module chunks = 1